import { render, staticRenderFns } from "./bwdjc.vue?vue&type=template&id=5cf0281e&"
import script from "./bwdjc.vue?vue&type=script&lang=js&"
export * from "./bwdjc.vue?vue&type=script&lang=js&"
import style0 from "./bwdjc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports